module.exports = __webpack_public_path__ + "img/flag_gb.afb8910.svg";